import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.research.id');
import { OnInit, Input, DoCheck } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-research-id',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.research.id/view.scss */
/* src/app/page.research.id/view.scss: no such file or directory */`],
})
export class PageResearchIdComponent implements OnInit, DoCheck {

    public id: any = '';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(true, "/login");
        this.id = WizRoute.segment.id;
        await this.service.render();
    }

    public async ngDoCheck() {
        this.id = WizRoute.segment.id;
    }
}

export default PageResearchIdComponent;